import { Grid, Typography } from '@mui/material';
import React from 'react';
import { ImageAndText } from '../../atoms/ImageAndText';
import { SHOPIFY_WEB_URL } from '../../config';

export const StressUpsellSection = (): JSX.Element => {
  return (
    <Grid
      item
      sx={{
        py: 12,
        px: { xs: 3, md: 0 },
      }}
    >
      <ImageAndText
        imgSrc="/images/cortisol_test.png"
        imgAlt="Rootine multivitamin box"
        subtitle1="TEST YOUR CORTISOL"
        subtitle2="ACCESS IMPROVEMENT PLAN"
        title="Want to conquer your stress? We have a solution for that too!"
        description={
          <Grid container flexDirection="column">
            <Typography fontSize={24} variant="light" sx={{ mt: 4, mb: 1 }}>
              Cortisol is your stress hormone, and when it is off balance it can
              impact your weight, energy levels, mood, sleep, productivity, etc.
            </Typography>
            <Typography fontSize={24} variant="light" sx={{ mt: 4, mb: 8 }}>
              With our easy-to-take, at-home cortisol test, you will learn about
              your cortisol type, and receive expert recommendations for one our
              all natural stress supplements.{' '}
            </Typography>
          </Grid>
        }
        primaryButton={{
          label: 'Start with Improving Stress',
          url: `${SHOPIFY_WEB_URL}/products/cortisol-test`,
          ariaLabel: 'Buy cortisol stress test now',
          hideIcon: true,
        }}
        reverseLayout
        isTitleSecondaryColor
      />
    </Grid>
  );
};
